<script>
import { mapActions, mapState } from "vuex";

export default {
  props: ["callback"],

  data() {
    return {
      // ID of role to assign
      roleId: null,

      // The email to send the invitation to
      email: "",
    };
  },

  computed: {
    roleOptions() {
      return Object.values(this.roles).map((role) => {
        return { text: role.name, value: role.id };
      });
    },

    // Mapped vuex state
    ...mapState(["roles"]),
  },

  // When the component is created, get the team's roles
  async created() {
    await this.getRoles("id,name");
  },

  methods: {
    // When the form is submitted, post a new team invitiation
    async submit() {
      // Send invitation given the form data
      const invitationSuccess = await this.postTeamInvitations({
        roleId: this.roleId,
        email: this.email,
      });

      // If invitation was successful, then clear form
      if (invitationSuccess) {
        this.roleId = null;
        this.email = "";
      }

      this.callback();
    },

    // Mapped vuex actions
    ...mapActions(["postTeamInvitations", "getRoles"]),
  },
};
</script>

<template>
  <b-col>
    <b-form @submit.stop.prevent="submit">
      <b-row>
        <b-col cols="12" sm="auto" class="flex-sm-grow-1">
          <b-form-group id="email-group" label="Email" label-for="email">
            <b-form-input
              id="email"
              v-model="email"
              placeholder="Email"
            ></b-form-input>
            <small class="form-text text-muted">Email of user to invite</small>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="3">
          <b-form-group id="role-group" label="Role" label-for="role">
            <b-form-select
              required
              id="role"
              v-model="roleId"
              :options="roleOptions"
            >
              <template #first>
                <option :value="null" disabled>Role</option>
              </template>
            </b-form-select>
            <small class="form-text text-muted">Role of invited user</small>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="auto">
          <b-button
            type="submit"
            variant="primary"
            class="Send-invitation-button"
          >
            Send
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-col>
</template>

<style scoped>
@media (min-width: 576px) {
  .Send-invitation-button {
    margin-top: 2rem;
    float: right;
  }
}
</style>
